import { useState } from 'react';
import type { BotProfileView, ServiceView, SlotView } from '@masterzapis/types';
import { durationLabel, fullDateLabel } from '../format';
import { openExternal } from '../telegram';

interface Props {
  profile: BotProfileView;
  service: ServiceView;
  slot: SlotView;
  date: string;
  /** Телефон, который клиент оставлял раньше; null — спросим сейчас */
  knownPhone: string | null;
  busy: boolean;
  onSubmit: (payload: { comment?: string; phone?: string }) => void;
}

export function ConfirmBooking({
  profile,
  service,
  slot,
  date,
  knownPhone,
  busy,
  onSubmit,
}: Props) {
  const [phone, setPhone] = useState('');
  const [comment, setComment] = useState('');

  const needsPhone = profile.requirePhone && !knownPhone;
  const phoneReady = !needsPhone || /^\+?\d{10,15}$/.test(phone.replace(/[\s()-]/g, ''));

  return (
    <div>
      <p className="section-title">Проверьте запись</p>
      <div className="summary">
        <div className="summary-row">
          <span>Услуга</span>
          <span>{service.name}</span>
        </div>
        <div className="summary-row">
          <span>Когда</span>
          <span>
            {fullDateLabel(date)}, {slot.time}
          </span>
        </div>
        <div className="summary-row">
          <span>Длительность</span>
          <span>{durationLabel(service.durationMinutes)}</span>
        </div>
        <div className="summary-row">
          <span>Стоимость</span>
          <span>{service.priceFormatted}</span>
        </div>
      </div>

      {needsPhone && (
        <div className="field">
          <label htmlFor="phone">Телефон для связи</label>
          <input
            id="phone"
            type="tel"
            inputMode="tel"
            placeholder="+7 999 123-45-67"
            value={phone}
            onChange={(event) => setPhone(event.target.value)}
          />
          <p className="hint">
            Отправляя номер, вы соглашаетесь с{' '}
            <a
              href="/legal/privacy.html"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(event) => {
                event.preventDefault();
                openExternal('/legal/privacy.html');
              }}
            >
              политикой обработки персональных данных
            </a>
            .
          </p>
        </div>
      )}

      <div className="field">
        <label htmlFor="comment">Комментарий мастеру, если нужно</label>
        <textarea
          id="comment"
          rows={2}
          maxLength={512}
          value={comment}
          onChange={(event) => setComment(event.target.value)}
        />
      </div>

      {!profile.autoConfirm && (
        <p className="note">Мастер подтвердит запись — пришлём уведомление в этот чат.</p>
      )}

      <div className="actions">
        <button
          className="button"
          disabled={busy || !phoneReady}
          onClick={() =>
            onSubmit({
              comment: comment.trim() || undefined,
              phone: needsPhone ? phone.replace(/[\s()-]/g, '') : undefined,
            })
          }
        >
          {busy ? 'Записываем…' : 'Записаться'}
        </button>
      </div>
    </div>
  );
}
